export const SKIP_TIME = 5;
export const AUDIO_ADJUST = 0.1;

export const SHORTCUTS = {
  NEXT_SONG: "n",
  PREVIOUS_SONG: "p",
  VOLUME_UP: "ArrowUp",
  VOLUME_DOWN: "ArrowDown",
  PLAY_PAUSE: " ",
  GO_FORWARD: "l",
  GO_BACK: "j",
  MUTE: "m",
  Loop: "rep"
};

export const SERVER_URL = "http://localhost:5020";
export const SONG_SERVER_URL = "https://spotifi.web.deuxfleurs.fr";
